import React from "react";
import {Scatter} from "react-chartjs-2";
import {
  Chart as ChartJS,
  ChartOptions,
  PointElement,
  LinearScale,
  TimeScale,
  TimeSeriesScale,
  Tooltip,
  Title,
} from "chart.js";
import {MEASUREMENT_POINT_COLORS} from "../../designSystem/tokens/chart";

ChartJS.register(
  PointElement,
  LinearScale,
  TimeScale,
  TimeSeriesScale,
  Tooltip,
  Title
);

const CHART_OPTION: ChartOptions<"scatter"> = {
  responsive: true,
  scales: {
    x: {
      type: "timeseries",
      time: {
        tooltipFormat: "yyyy-MM-dd HH:mm:ss",
      },
      title: {
        display: true,
        text: "時間",
      },
    },
    y: {
      title: {
        display: true,
        text: "值",
      },
      beginAtZero: false,
    },
  },
};

export const MeasurementChart = ({ measurements, metricType } ) => {
  const isBloodPressure = metricType === "bp";

  let datasets = [];

  if (isBloodPressure) {
    const systolicPoints = measurements.map((m) => ({
      x: new Date(m.dateTime),
      y: m.raw.measurement.systolic,
    }));

    const diastolicPoints = measurements.map((m) => ({
      x: new Date(m.dateTime),
      y: m.raw.measurement.diastolic,
    }));

    datasets = [
      {
        label: "收縮壓",
        data: systolicPoints,
        pointRadius: 6,
        pointBackgroundColor: MEASUREMENT_POINT_COLORS.bpSystolic,
        showLine: false,
      },
      {
        label: "舒張壓",
        data: diastolicPoints,
        pointRadius: 6,
        pointBackgroundColor: MEASUREMENT_POINT_COLORS.bpDiastolic,
        showLine: false,
      },
    ];
  } else {
    const singlePoints = measurements.map((m) => ({
      x: new Date(m.dateTime),
      y: m.value,
    }));

    datasets = [
      {
        label: "數據",
        data: singlePoints,
        pointRadius: 6,
        pointBackgroundColor: MEASUREMENT_POINT_COLORS.default,
        showLine: false,
      },
    ];
  }

  const data = { datasets };
  return (
    <Scatter data={data} options={CHART_OPTION} />
  )
}
